module.exports = __webpack_public_path__ + "img/crmlogo.71664064.svg";